export default __webpack_public_path__ + "static/scroll-top-icon-f35e90b1f50e95eea055a5d05618800e.png";